// reach_ui/src/components/VastGPT/MarkdownWithEllipsis.js
import React, { useState, useEffect } from 'react'

function MarkdownWithEllipsis({ markdown, loadingResponse }) {
  const [dots, setDots] = useState('.')

  useEffect(() => {
    const updateDots = () => {
      switch (dots) {
        case '.':
          setDots('..')
          break
        case '..':
          setDots('...')
          break
        case '...':
          setDots('.')
          break
        default:
          setDots('.')
      }
    }

    const interval = setInterval(updateDots, 250)

    // Cleanup the interval when the component is unmounted
    return () => clearInterval(interval)
  }, [dots]) // Re-run effect when `dots` changes

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: window.marked?.parse(
          `${markdown || ''}${
            loadingResponse === 'loadingWithText' ? dots : ''
          }`,
        ),
      }}
    />
  )
}

export default MarkdownWithEllipsis
